import Joi from 'joi';

const environments = ['development', 'production'];

const envSchema = Joi.object({
  VUE_APP_PORT: Joi.number().integer().min(1).max(65_535).required(),
  VUE_APP_ENVIRONMENT: Joi.string()
    .valid(...environments)
    .required(),
  VUE_APP_SERVER_URL: Joi.string().uri().required(),
  VUE_APP_GENERIC: Joi.string().uri().required(),
  VUE_APP_USER_GENERIC: Joi.string().required(),
  VUE_APP_PASSWORD_GENERIC: Joi.string().required(),
  VUE_APP_SERVER_API_KEY_ABIERTAS: Joi.string().required(),
  VUE_APP_SERVER_API_KEY: Joi.string().required(),
}).unknown(true);

const { error, value: envVars } = envSchema.validate(process.env);
if (error) {
  throw new Error(
    `❌ Error al validar las variables de entorno. ${error.message}`
  );
}

export default {
  enviroment: envVars.VUE_APP_ENVIRONMENT,
  serverUrl: envVars.VUE_APP_SERVER_URL,
  generic: envVars.VUE_APP_GENERIC,
  userGeneric: envVars.VUE_APP_USER_GENERIC,
  passwordGeneric: envVars.VUE_APP_PASSWORD_GENERIC,
  apiKeyAbierta: envVars.VUE_APP_SERVER_API_KEY_ABIERTAS,
  apiKeyServer: envVars.VUE_APP_SERVER_API_KEY,
};
